export const NAME = 'highIntentDashboard';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;

        case 'HIGH_INTENT_DASHBOARD__FETCH_SEGMENTS_DATA__END': {
            return {
                ...state,
                audienceSegments: action.payload.data,
            };
        }

        case 'HIGH_INTENT_DASHBOARD__INIT_START': {
            return {
                ...state,
                isLoading: true,
            };
        }

        case 'HIGH_INTENT_DASHBOARD__INIT_END': {
            return {
                ...state,
                isLoading: false,
                totalSegmentCount: action.payload.totalSegmentCount,
            };
        }
    }
}
